(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header-model-10"]) return;
  try {
    
(() => {
  if (customElements.get('ls26-native-menu-header')) return;
  class LSStoreHeader extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      const signal = this.controller.signal;
      this.browse = this.querySelector('[data-ls-browse]');
      this.mobileTrigger = this.querySelector('[data-ls-mobile-trigger]');
      this.mobileTrigger?.addEventListener('click', () => { this.browse.open = !this.browse.open; this.syncStates(); }, { signal });
      this.bar = this.querySelector('[data-ls-bar]');
      this.backdrop = this.querySelector('[data-ls-backdrop]');
      this.spacer = this.querySelector('[data-ls-spacer]');
      this.categories = [...this.querySelectorAll('[data-ls-category]')];
      this.desktop = matchMedia('(min-width:1366px)');
      this.keyboardNavigation = false;
      this.dataset.lsInputMode = 'pointer';
      document.addEventListener('keydown', () => { this.keyboardNavigation = true; this.dataset.lsInputMode = 'keyboard'; }, { capture:true, signal });
      document.addEventListener('pointerdown', () => { this.keyboardNavigation = false; this.dataset.lsInputMode = 'pointer'; }, { capture:true, signal });
      this.querySelectorAll('[data-ls-brand-search]').forEach(search => {
        search.hidden = false;
        const input = search.querySelector('[data-ls-brand-input]');
        const panel = search.closest('.lsnav__panel');
        const buttons = [...search.querySelectorAll('[data-ls-brand-range]')];
        const items = [...panel.querySelectorAll('[data-ls-brand-name]')];
        const normalize = value => value.normalize('NFKD').replace(/[\u0300-\u036f]/g, '').toLocaleLowerCase().trim();
        let range = 'ABC';
        const filterBrands = () => {
          const query = normalize(input.value);
          let matches = 0;
          items.forEach(item => {
            const name = normalize(item.dataset.lsBrandName);
            const first = name.charAt(0).toUpperCase();
            const inRange = range === 'all' || (range === 'other' ? !'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789'.includes(first) : range.includes(first));
            item.hidden = !(inRange && name.includes(query));
            if (!item.hidden) matches++;
          });
          buttons.forEach(button => button.setAttribute('aria-pressed', String(button.dataset.lsBrandRange === range)));
          search.querySelector('[data-ls-brand-empty]').hidden = matches > 0;
          this.updatePanelHeight();
        };
        const searchBrands = () => { range = 'all'; filterBrands(); };
        input.addEventListener('input', searchBrands, { signal });
        input.addEventListener('search', searchBrands, { signal });
        buttons.forEach(button => button.addEventListener('click', () => {
          range = button.dataset.lsBrandRange;
          input.value = '';
          filterBrands();
        }, { signal }));
        filterBrands();
      });
      this.querySelectorAll('[data-ls-close]').forEach(button => { button.hidden = false; });
      this.syncViewport();
      this.desktop.addEventListener('change', () => this.syncViewport(), { signal });
      this.categories.forEach(category => {
        category.addEventListener('pointerenter', event => {
          if (!this.desktop.matches || event.pointerType !== 'mouse') return;
          this.keyboardNavigation = false;
          this.dataset.lsInputMode = 'pointer';
          this.clearHoverTimer();
          if (!this.isConnected) return;
          const focusedCategory = this.categories.find(other => other !== category && other.open && other.contains(document.activeElement));
          if (focusedCategory) document.activeElement.blur();
          this.categories.forEach(other => { other.open = other === category; });
          this.syncStates();
          this.updatePanelHeight();
        }, { signal });
        category.addEventListener('pointerleave', event => {
          if (!this.desktop.matches || event.pointerType !== 'mouse') return;
          this.clearHoverTimer();
          this.hoverTimer = setTimeout(() => {
            this.hoverTimer = 0;
            if (!(this.keyboardNavigation && category.contains(document.activeElement))) this.closeCategory(category, false);
          }, 180);
        }, { signal });
        category.addEventListener('pointerdown', () => this.clearHoverTimer(), { signal });
        category.addEventListener('focusin', () => this.clearHoverTimer(), { signal });
        category.addEventListener('toggle', () => {
          if (category.open) this.categories.forEach(other => { if (other !== category) other.open = false; });
          this.syncStates();
          this.updatePanelHeight();
        }, { signal });
      });
      this.browse.addEventListener('toggle', () => this.syncStates(), { signal });
      this.addEventListener('click', event => {
        if (event.target.closest('[data-ls-backdrop]')) this.closeAll(false);
        if (event.target.closest('[data-ls-close]')) this.closeCategory(event.target.closest('[data-ls-category]'), true);
      }, { signal });
      document.addEventListener('click', event => {
        if (!this.contains(event.target)) this.closeAll(false);
      }, { signal });
      this.addEventListener('keydown', event => {
        if (event.key !== 'Escape') return;
        this.clearHoverTimer();
        const category = event.target.closest('[data-ls-category]');
        if (category?.open) this.closeCategory(category, true);
        else if (!this.desktop.matches) { this.browse.open = false; const returnTarget = this.mobileTrigger?.getClientRects().length ? this.mobileTrigger : this.browse.querySelector('summary'); returnTarget.focus(); }
        event.preventDefault();
      }, { signal });
      document.addEventListener('keydown', event => {
        if (event.key === 'Escape' && !this.contains(event.target)) this.closeAll(false);
      }, { signal });
      this.addEventListener('focusout', event => {
        if (event.relatedTarget && !this.contains(event.relatedTarget)) this.closeAll(false);
      }, { signal });
      window.addEventListener('scroll', () => this.scheduleLayout(), { passive:true, signal });
      window.addEventListener('resize', () => this.scheduleLayout(), { passive:true, signal });
      this.resizeObserver = new ResizeObserver(() => this.scheduleLayout());
      this.resizeObserver.observe(this.querySelector('[data-ls-main]'));
      this.resizeObserver.observe(this.bar);
      this.resizeObserver.observe(this.browse);
      this.countElement = this.querySelector('[data-ls26-cart-count]');
      this.lastCount = this.countElement.textContent;
      this.cartObserver = new MutationObserver(() => {
        const count = this.countElement.textContent;
        if (count !== this.lastCount) { this.lastCount = count; this.refreshCart(); }
      });
      this.cartObserver.observe(this.countElement, { childList:true, characterData:true, subtree:true });
      ['cart:updated','cart:refresh','cart:change'].forEach(name => document.addEventListener(name, () => this.refreshCart(), { signal }));
      document.addEventListener('visibilitychange', () => { if (!document.hidden) this.refreshCart(); }, { signal });
      window.addEventListener('pageshow', () => this.refreshCart(), { signal });
      this.addEventListener('pointerenter', event => { if (event.target.closest('[data-ls-cart]')) this.refreshCart(); }, { capture:true, signal });
      this.syncStates();
      this.scheduleLayout();
    }
    disconnectedCallback() {
      this.clearHoverTimer();
      this.controller?.abort();
      this.controller = null;
      this.resizeObserver?.disconnect();
      this.cartObserver?.disconnect();
      cancelAnimationFrame(this.frame);
      document.documentElement.style.removeProperty('--ls26-sticky-header-height');
    }
    syncViewport() {
      this.clearHoverTimer();
      this.browse.open = this.desktop.matches;
      this.categories.forEach(category => { category.open = false; });
      if (!this.desktop.matches) this.querySelectorAll('.lsnav__panel').forEach(panel => panel.style.removeProperty('max-height'));
      this.syncStates();
      this.scheduleLayout();
    }
    syncStates() {
      this.mobileTrigger?.setAttribute('aria-expanded', String(this.browse.open));
      this.backdrop.hidden = !(this.desktop.matches && this.categories.some(category => category.open));
      [this.browse,...this.categories].forEach(details => details.querySelector('summary').setAttribute('aria-expanded', String(details.open)));
    }
    closeCategory(category, focus) {
      this.clearHoverTimer();
      if (!category) return;
      category.open = false;
      this.syncStates();
      if (focus) category.querySelector('summary').focus();
    }
    closeAll(focus) {
      this.clearHoverTimer();
      this.categories.forEach(category => this.closeCategory(category, focus && category.open));
      if (!this.desktop.matches) this.browse.open = false;
      this.syncStates();
    }
    scheduleLayout() {
      if (this.frame) return;
      this.frame = requestAnimationFrame(() => { this.frame = 0; this.updateLayout(); });
    }
    clearHoverTimer() {
      clearTimeout(this.hoverTimer);
      this.hoverTimer = 0;
    }
    updateLayout() {
      const anchor = this.spacer.getBoundingClientRect();
      const stick = this.desktop.matches && anchor.top < 0;
      this.bar.classList.toggle('is-fixed', stick);
      this.spacer.style.height = stick ? `${this.bar.offsetHeight}px` : '0px';
      if (this.desktop.matches) document.documentElement.style.setProperty('--ls26-sticky-header-height', `${this.bar.offsetHeight}px`);
      else document.documentElement.style.removeProperty('--ls26-sticky-header-height');
      this.updatePanelHeight();
    }
    updatePanelHeight() {
      if (!this.desktop.matches) return;
      const available = Math.max(120, window.innerHeight - this.bar.getBoundingClientRect().bottom - 16);
      this.querySelectorAll('.lsnav__panel').forEach(panel => { panel.style.maxHeight = `${available}px`; });
    }
    async refreshCart() {
      if (this.refreshing) return;
      this.refreshing = true;
      try {
        const response = await fetch(this.dataset.cartUrl, { credentials:'same-origin', cache:'no-store', signal:this.controller.signal });
        if (!response.ok) return;
        const cart = await response.json();
        this.lastCount = String(cart.item_count);
        this.countElement.textContent = this.lastCount;
        this.querySelector('[data-ls26-cart-total]').textContent = new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {style:'currency',currency:cart.currency}).format(cart.total_price / 100);
        this.querySelector('[data-ls-cart]').setAttribute('aria-label', this.dataset.basketLabel.replace('[count]', cart.item_count));
      } catch (_) {
      } finally {
        this.refreshing = false;
      }
    }
  }
  customElements.define('ls26-native-menu-header', LSStoreHeader);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sidebar-category"]) return;
  try {
    
$(document).ready(function(){
  $(".dt-menu-expand").click(function(event){
    event.preventDefault();
    if( $(this).hasClass("dt-mean-clicked") ){
      $(this).text("+");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideUp(400);
      } else {
        $(this).prev('.megamenu-child-container').find('ul:first').slideUp(600);
      }
    } else {
      $(this).text("-");
      if( $(this).prev('ul').length ) {
        $(this).prev('ul').slideDown(400);
      } else{
        $(this).prev('.megamenu-child-container').find('ul:first').slideDown(2000);
      }
    }

    $(this).toggleClass("dt-mean-clicked");
    return false;
  });

});
      

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["home-sidebar-featured-postBk"]) return;
  try {
    
$(document).ready(function(){
     var homeSidefp = $(".home-sidebar-featured-post__inner");
      homeSidefp.owlCarousel({
      items:1,
      dots: false,  
      autoplay:true,
      smartSpeed : 1000,
      navSpeed : 1000,
         responsive:{
      0:{
      items: 1
      },
      600:{
      items:1
      },
      700:{
      items:1
      },
      1000:{
      items: 1
      }
      }
      });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls26-gift-category"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialize = scope => {
    scope.querySelectorAll('[data-occasion-gifts]').forEach(root => {
      if (root.dataset.ready) return;
      const grid = root.querySelector('[data-occasion-grid]');
      const template = root.querySelector('[data-all-occasion-gifts]');
      const heading = root.querySelector('[data-gift-results-heading]');
      const status = root.querySelector('[data-occasion-status]');
      const reset = root.querySelector('[data-occasion-reset]');
      const picker = root.querySelector('.lsgc-occasion-picker');
      if (!grid || !template || !template.content.children.length) return;
      root.dataset.ready = 'true';
      const originalGrid = grid.cloneNode(true);
      const originalHeading = heading.textContent;
      const pagination = root.querySelector('.lsgc-pagination');
      const buttons = Array.from(root.querySelectorAll('[data-gift-occasion]'));
      const cards = Array.from(template.content.children);
      let lastOrder = cards.map((_, index) => index).join(',');
      buttons.forEach(button => button.addEventListener('click', () => {
        const order = cards.map((_, index) => index);
        for (let i = order.length - 1; i > 0; i--) {
          const j = Math.floor(Math.random() * (i + 1));
          [order[i], order[j]] = [order[j], order[i]];
        }
        if (order.length > 1 && order.join(',') === lastOrder) order.push(order.shift());
        lastOrder = order.join(',');
        const fragment = document.createDocumentFragment();
        order.forEach(index => fragment.append(cards[index].cloneNode(true)));
        grid.replaceChildren(fragment);
        const occasion = button.querySelector('[data-occasion-label]').textContent.trim();
        heading.textContent = root.dataset.resultTemplate.replace('__OCCASION__', occasion).replace('__COUNT__', String(cards.length));
        status.textContent = status.dataset.message;
        buttons.forEach(item => item.setAttribute('aria-pressed', String(item === button)));
        reset.hidden = false;
        if (pagination) pagination.hidden = true;
      }));
      reset.addEventListener('click', () => {
        grid.replaceChildren(...Array.from(originalGrid.children).map(card => card.cloneNode(true)));
        heading.textContent = originalHeading;
        status.textContent = '';
        buttons.forEach(button => button.setAttribute('aria-pressed', 'false'));
        reset.hidden = true;
        if (pagination) pagination.hidden = false;
      });
      picker.hidden = false;
    });
  };
  initialize(document);
  document.addEventListener('shopify:section:load', event => initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls26-gift-minimal"] && !Shopify.designMode) return;
  try {
    
(() => {
 const initialize = scope => {
   scope.querySelectorAll('[data-gift-note-motion]').forEach(tag => {
     if (tag.dataset.motionReady) return;
     tag.dataset.motionReady = 'true';
     tag.addEventListener('click', () => {
       const paused = tag.getAttribute('aria-pressed') !== 'true';
       tag.setAttribute('aria-pressed', String(paused));
       tag.setAttribute('aria-label', paused ? 'Resume gift tag movement' : 'Pause gift tag movement');
     });
   });
   scope.querySelectorAll('[data-gift-sort]').forEach(sort => {
   if (sort.dataset.sortReady) return;
   sort.dataset.sortReady = 'true';
   sort.addEventListener('change', () => {
     const url = new URL(location.href);
     url.searchParams.set('sort_by', sort.value);
     url.searchParams.delete('page');
     url.searchParams.delete('ls26_stock_page');
     location.assign(url.href);
   });
 });
 };
 initialize(document);
 document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ls26-hamper-collection"] && !Shopify.designMode) return;
  try {
    
  (() => {
    function setup(root) {
      if (root.dataset.ready) return;
      root.dataset.ready = 'initialising';
      const cards = Array.from(root.querySelectorAll('[data-all-gifts-grid] [data-gift-groups]'));
      const shelves = root.querySelector('[data-gift-shelves]');
      const allGrid = root.querySelector('[data-all-gifts-grid]');
      const imageDialog = root.querySelector('[data-image-dialog]');
      if (typeof imageDialog.showModal === 'function') {
        root.querySelectorAll('[data-image-open]').forEach(button => {
          button.hidden = false;
          button.addEventListener('click', () => {
            const card = button.closest('.lsh-product');
            const source = card.querySelector('.lsh-product-image');
            const image = document.createElement('img');
            image.src = source.dataset.zoomSrc;
            image.alt = source.querySelector('img').alt;
            root.querySelector('[data-image-title]').textContent = card.querySelector('h3').textContent;
            root.querySelector('[data-image-view]').replaceChildren(image);
            root.querySelector('[data-image-details]').href = source.href;
            imageDialog.showModal();
          });
        });
        root.querySelector('[data-image-close]').addEventListener('click', () => imageDialog.close());
        imageDialog.addEventListener('click', event => {
          if (event.target !== imageDialog) return;
          const box = imageDialog.getBoundingClientRect();
          if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) imageDialog.close();
        });
      }
      const catalog = root.querySelector('.lsh-catalog');
      const links = Array.from(root.querySelectorAll('[data-gift-category]'));
      const counter = root.querySelector('[data-result-count]');
      const activeCategory = root.querySelector('[data-active-category]');
      const empty = root.querySelector('[data-category-empty]');
      let currentCategory = '';
      let currentBrowseAll = false;
      const scrollTo = (node) => node.scrollIntoView({behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start'});
      function filter(category, updateUrl, scroll, browseAll = false) {
        const allowed = links.find(link => link.dataset.giftCategory === category);
        currentCategory = allowed ? category : '';
        currentBrowseAll = !allowed && browseAll;
        const overview = !allowed && !currentBrowseAll;
        shelves.hidden = !overview;
        allGrid.hidden = overview;
        root.querySelector('[data-browse-query]').disabled = !currentBrowseAll;
        const categoryQuery = root.querySelector('[data-category-query]');
        categoryQuery.value = currentCategory;
        categoryQuery.disabled = !currentCategory;
        let count = 0;
        cards.forEach(card => {
          card.hidden = Boolean(currentCategory) && !card.dataset.giftGroups.split(' ').includes(currentCategory);
          if (!card.hidden) count += 1;
        });
        links.forEach(link => { if (link === allowed) link.setAttribute('aria-current', 'true'); else link.removeAttribute('aria-current'); });
        counter.textContent = (overview ? root.dataset.overviewCount : root.dataset.countTemplate).replace('__COUNT__', String(count));
        activeCategory.hidden = !allowed && !currentBrowseAll;
        if (currentBrowseAll) root.querySelector('[data-category-name]').textContent = root.dataset.allLabel;
        if (allowed) root.querySelector('[data-category-name]').textContent = allowed.dataset.giftLabel;
        empty.hidden = count > 0;
        if (updateUrl) {
          const url = new URL(window.location.href);
          if (currentCategory) url.searchParams.set('gift', currentCategory); else url.searchParams.delete('gift');
          if (currentBrowseAll) url.searchParams.set('browse', 'all'); else url.searchParams.delete('browse');
          url.hash = catalog.id;
          history.pushState({}, '', url);
        }
        if (scroll) { scrollTo(catalog); catalog.focus({preventScroll: true}); }
      }
      links.forEach(link => link.addEventListener('click', event => {
        event.preventDefault();
        filter(link.dataset.giftCategory, true, true);
      }));
      root.querySelectorAll('[data-view-all]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); filter(link.dataset.viewAll, true, true); }));
      root.querySelectorAll('[data-browse-all]').forEach(link => link.addEventListener('click', event => { event.preventDefault(); filter('', true, true, true); }));
      root.querySelectorAll('[data-reset-category]').forEach(link => link.addEventListener('click', event => {
        const remainingParams = new URLSearchParams(window.location.search);
        remainingParams.delete('gift');
        remainingParams.delete('browse');
        if (remainingParams.size) return;
        event.preventDefault(); filter('', true, true);
      }));
      root.querySelector('[data-clear-category]').addEventListener('click', () => filter('', true, true));
      function readBrowseState() {
        const params = new URLSearchParams(window.location.search);
        filter(params.get('gift'), false, false, params.get('browse') === 'all');
      }
      window.addEventListener('popstate', readBrowseState);
      readBrowseState();
      const toggle = root.querySelector('[data-message-toggle]');
      const message = root.querySelector('[data-message-text]');
      const recipient = root.querySelector('[data-message-recipient]');
      function syncMessage() {
        if (!toggle) return;
        root.querySelector('[data-message-fields]').hidden = !toggle.checked;
        root.querySelector('[data-message-count]').textContent = `${message.value.length} / ${message.maxLength}`;
        const toPreview = root.querySelector('[data-recipient-preview]');
        toPreview.textContent = recipient.value.trim() ? `${toPreview.dataset.to} ${recipient.value.trim()},` : toPreview.dataset.default;
        const preview = root.querySelector('[data-message-preview]');
        preview.textContent = message.value.trim() || preview.dataset.default;
        root.querySelectorAll('[data-gift-property]').forEach(input => {
          const value = input.dataset.giftProperty === 'message' ? message.value.trim() : recipient.value.trim();
          input.value = value;
          input.disabled = !toggle.checked || !message.value.trim() || !value;
        });
      }
      if (toggle) {
        toggle.addEventListener('change', syncMessage);
        message.addEventListener('input', syncMessage);
        recipient.addEventListener('input', syncMessage);
        root.querySelectorAll(`a[href="#${root.id}-personalise"]`).forEach(link => link.addEventListener('click', event => {
          event.preventDefault(); toggle.checked = true; syncMessage(); scrollTo(root.querySelector('.lsh-personalise')); message.focus({preventScroll: true});
        }));
        syncMessage();
      }
      root.querySelectorAll('[data-variant-select]').forEach(select => select.addEventListener('change', () => {
        const card = select.closest('.lsh-product');
        const option = select.selectedOptions[0];
        card.querySelector('[data-variant-price]').textContent = option.dataset.price;
        const imageLink = card.querySelector('.lsh-product-image');
        const image = imageLink.querySelector('img');
        if (image && option.dataset.image) {
          image.src = option.dataset.image;
          image.srcset = `${option.dataset.imageSmall} 400w, ${option.dataset.image} 1000w`;
          imageLink.dataset.zoomSrc = option.dataset.zoom;
        }
        card.querySelectorAll('a[href*="/products/"]').forEach(link => {
          const url = new URL(link.href);
          url.searchParams.set('variant', option.value);
          link.href = url.href;
        });
        const available = option.dataset.available === 'true';
        card.querySelector('[data-stock-label]').textContent = available ? root.dataset.inStock : root.dataset.sold;
        const button = card.querySelector('[type=submit]');
        button.disabled = !available;
        button.textContent = available ? root.dataset.add : root.dataset.sold;
      }));
      root.addEventListener('submit', async event => {
        const form = event.target.closest('.lsh-product-form');
        if (!form || !window.fetch) return;
        event.preventDefault();
        event.stopImmediatePropagation();
        const button = form.querySelector('[type=submit]');
        if (button.disabled || form.dataset.busy) return;
        if (toggle && toggle.checked && !message.value.trim()) {
          message.setCustomValidity(message.placeholder);
          message.reportValidity();
          message.addEventListener('input', () => message.setCustomValidity(''), {once: true});
          scrollTo(root.querySelector('.lsh-personalise'));
          message.focus({preventScroll: true});
          return;
        }
        syncMessage();
        form.dataset.busy = 'true';
        button.disabled = true;
        button.textContent = root.dataset.adding;
        const status = form.querySelector('[data-product-status]');
        status.textContent = '';
        status.removeAttribute('data-error');
        try {
          const base = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
          const response = await fetch(`${base}cart/add.js`, {method: 'POST', credentials: 'same-origin', headers: {Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest'}, body: new FormData(form)});
          const data = await response.json();
          if (!response.ok) throw new Error(data.description || data.message || root.dataset.error);
          const link = document.createElement('a');
          link.href = `${base}cart`;
          link.textContent = root.dataset.added;
          status.replaceChildren(link);
          document.dispatchEvent(new CustomEvent('cart:updated', {detail: {item: data}}));
          document.dispatchEvent(new CustomEvent('ls26:cart-updated', {detail: {item: data}}));
        } catch (error) {
          status.dataset.error = 'true';
          status.textContent = error.message || root.dataset.error;
        } finally {
          delete form.dataset.busy;
          button.disabled = false;
          button.textContent = root.dataset.add;
        }
      }, true);
      root.dataset.ready = 'true';
    }
    document.querySelectorAll('[data-hamper-collection]').forEach(setup);
    document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-hamper-collection]').forEach(setup));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sidebar-promo-img-2"]) return;
  try {
    
 $(document).ready(function(){
     var promoimage_2 = $("#promo-carousel_2");
      promoimage_2.owlCarousel({
         items:1,
         loop:false,              
         dots: false,  
          autoplay:true,
         responsive:{
           0:{
             items: 1
           },
           600:{
             items:1
           },
           700:{
             items: 1
           },           
           1000:{
             items: 1
           }
         }
  			});
        });

  } catch(e) { console.error(e); }
})();
})();
